var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.show)?_c('div',[(!_setup.isPC)?_c('div',{class:[
      'bottom-popup',
      !_setup.isPC && 'bottom-popup-h5',
      !_setup.isPC && _setup.props.modal && 'bottom-popup-modal',
    ],on:{"click":_setup.onUniClickModal}},[(!_setup.isPC)?_c('div',{ref:"dialogRef",class:['bottom-popup-main', !_setup.isPC && 'bottom-popup-h5-main'],style:({ height: _setup.props.height }),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2):_vm._e()]):_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }